import { render, staticRenderFns } from "./JTMSDiscounts.vue?vue&type=template&id=55832b49&scoped=true&"
import script from "./JTMSDiscounts.vue?vue&type=script&lang=ts&"
export * from "./JTMSDiscounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55832b49",
  null
  
)

export default component.exports